import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';

import { differenceInCalendarDays } from 'date-fns';
import { Observable } from 'rxjs';

import { LayoutService } from '@rx-applications/shared/utils';
import { PaymentSummaryCommissionModel } from '@app/layout-app/shared';
import { ConfigFacade } from '@rx-applications/clientsite/shared/config/data-access';
import { TaxesAndFeesService } from '@app/layout-app/booking/shared/services/taxes-and-fees.service';
import { InternationalizationService } from '@rx-applications/clientsite/shared/internationalization/data-access';
import { RoomsFacade } from '@rx-applications/clientsite/search/hotel/api';
import { PaymentSummaryRoomModel } from '@rx-applications/clientsite/shared/utils';

@Component({
  selector: 'rx-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentSummaryComponent implements OnInit {
  @Input() showButton: boolean;
  @Input() disableButton: boolean;
  @Input() hotelId: number;
  @Input() hotelName: string;
  @Input() thumbnailUrl?: string;
  @Input() rooms: PaymentSummaryRoomModel[];
  @Input() checkInDate: string;
  @Input() checkOutDate: string;
  @Input() totalPrice: number;
  @Input() commission: PaymentSummaryCommissionModel;
  @Input() adultsAmount?: number;
  @Input() paymentType?: string;
  @Input() shadedTotal = false;
  @Input() saverPlusFee?: number;
  @Input() modalLayout = false;
  @Input() taxesAndFeesLayout = false;
  @Input() hideDueAtCheckIn = false;

  @Output() clickButton = new EventEmitter();

  readonly saverplusSameDayRate$ = inject(ConfigFacade).saverplusSameDayRate$;
  taxesAndFeesService: TaxesAndFeesService = inject(TaxesAndFeesService);

  constructor(
    public roomsFacade: RoomsFacade,
    private layoutService: LayoutService,
    private internationalizationService: InternationalizationService,
  ) {}

  staticDisplay$: Observable<boolean>;

  ngOnInit() {
    this.staticDisplay$ = this.layoutService.isDesktop$;
  }

  get dateFormat() {
    return this.internationalizationService.getCheckinDateFormat(this.checkInDate, this.checkOutDate);
  }

  get nightsAmount(): number {
    return differenceInCalendarDays(new Date(this.checkOutDate), new Date(this.checkInDate));
  }

  get salesTax(): number {
    return this.rooms.reduce((total: number, current: PaymentSummaryRoomModel) => total + (current.salesTax || 0), 0);
  }
}
